import createIcon from '../../createIcon';

/**
 * @component @name DesktopMac
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgM0g0QzIuOSAzIDIgMy45IDIgNVYxNkMyIDE3LjEgMi45IDE4IDQgMThIMTBMOCAyMFYyMUgxNlYyMEwxNCAxOEgyMEMyMS4xIDE4IDIyIDE3LjEgMjIgMTZWNUMyMiAzLjkgMjEuMSAzIDIwIDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DesktopMac = createIcon('DesktopMac', [
  [
    'path',
    {
      d: 'M20 3H4C2.9 3 2 3.9 2 5V16C2 17.1 2.9 18 4 18H10L8 20V21H16V20L14 18H20C21.1 18 22 17.1 22 16V5C22 3.9 21.1 3 20 3Z',
      key: '1jatr9',
    },
  ],
]);

export default DesktopMac;
